import { schema } from "normalizr";

export const moduleSchema = new schema.Entity(
  "modules",
  {},
  { idAttribute: "contentKey" }
);
export const topicsSchema = new schema.Entity(
  "topics",
  {},
  { idAttribute: "contentKey" }
);
export const keyTermSchema = new schema.Entity(
  "keyTerms",
  {},
  { idAttribute: "contentKey" }
);
export const activitySchema = new schema.Entity(
  "activities",
  {},
  { idAttribute: "contentKey" }
);
export const pageSchema = new schema.Entity(
  "pages",
  {},
  { idAttribute: "contentKey" }
);
